export const exportReportText = {
  successExportText: 'Download file Report berhasil',
  failedExportText: 'Download file Report gagal!',
  loadingExportText: 'Sedang mendownload file Report',
};

export const reportAttendanceTabText = {
  operatorTabText: 'Operator',
  hostTabText: 'Host',
};
